$(document).ready(function() {
    const ageSection = $('.age_section');
    const yesButton = $('#yes-button');
    const noButton = $('#no-button');
    const tooYoungMessage = $('.age_no');
    const buttonsContainer = $('.age_buttons-wrapper');

    const isVerified = $.cookie('age-verified');

    if (!isVerified) {
      ageSection.css('display', 'block'); 
      $('body').css('overflow', 'hidden');
    } else {
      ageSection.css('display', 'none'); 
    }

    yesButton.click(function() {
      $.cookie('age-verified', 'true', { path: '/' });
      ageSection.css('display', 'none');
      $('body').css('overflow', 'auto');
    });


    noButton.click(function() {
      buttonsContainer.css('display', 'none');
      tooYoungMessage.css('display', 'flex');
    });
  });